/** Warm ajedrez chunks while the user is on the train hub (idle / hover). */
let warm
export function prefetchAjedrez() {
  if (!warm) {
    warm = Promise.all([
      import('./AjedrezGame.jsx'),
      import('./ChessBoard3D.jsx'),
    ])
  }
  return warm
}
